import React from 'react'
import ReactResizeDetector from 'react-resize-detector'
import { hydrate } from 'react-dom'
import { CacheProvider } from '@emotion/react'
import { PAYPAL_THEME, ThemeWrapper } from '@paypalcorp/pp-react'
import createCache from '@emotion/cache'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

import ErrorBoundary from 'components/ErrorBoundary'
import { initWorldReady } from 'lib/initWorldReady'
import ErrorFallback from 'views/Shopping/components/ErrorFallback'
import ResizeObserverContext from './shoplist-app/store/lib/resize-observer-context'
import StorePage from './shoplist-app/store/StorePage'
import { RecentSearchesProvider } from './contexts/RecentSearchesContext/RecentSearchesContext'

/* About ReactDOM.hydrate():
 * Because the page is already rendered on the server side,
 * there is no need to render it again on the client side.
 * But we have to use ReactDOM.hydrate() to make sure all the pp-react
 * styles are applied and javascript event handlers are attached.
 *
 * About window.__SERVER_DATA__:
 * API calls such as Honey API call have already been performed on the server side.
 * There is no need to make the same calls again on the client side.
 * We just store the data in the DOM and pass it to React from there.
 * See: server/src/lib/static-react.js
 */
const serverData = __SERVER_DATA__

// Initiatlize localization on the client-side
initWorldReady(serverData.worldReady, serverData.env.test)
const worldReadyLocale = {
  payPalLocaleCode: {
    country: serverData.locale.country,
    locale: serverData.locale.locale
  }
}

hydrate(
  <WorldReadyContextProvider locale={worldReadyLocale}>
    <ErrorBoundary FallbackComponent={() => <ErrorFallback useGenericError />}>
      <CacheProvider value={createCache({ key: 'store', prepend: true })}>
        <ReactResizeDetector handleWidth>
          {({ width }: { width: number }) => {
            return (
              <ResizeObserverContext.Provider value={width}>
                <ThemeWrapper theme={PAYPAL_THEME}>
                  <RecentSearchesProvider>
                    <StorePage serverData={serverData} />
                  </RecentSearchesProvider>
                </ThemeWrapper>
              </ResizeObserverContext.Provider>
            )
          }}
        </ReactResizeDetector>
      </CacheProvider>
    </ErrorBoundary>
  </WorldReadyContextProvider>,
  document.getElementById('store_root')
)
